import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateTemporalFulfillmentPlan } from 'redux/actions/cotizacionActions'
import { deliveryPlansForCotization } from 'Utils/constants'

const DeliveryPlan = ({ isHomeDelivery, fulfillmentPlanIdSelected }) => {
  const hasAutoSelectedRef = useRef(false)

  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart.cart)
  const [deliveryTypeState, setDeliveryTypeState] = useState(null)

  const deliveryPlanData = useMemo(() => {
    return isHomeDelivery
      ? deliveryPlansForCotization.homeDelivery
      : deliveryPlansForCotization.branchDelivery
  }, [isHomeDelivery])

  const handleSelectDeliveryPlan = useCallback(
    item => {
      setDeliveryTypeState(item)
      dispatch(
        updateTemporalFulfillmentPlan({
          fulfillmentPlanId: item.fulfillmentPlanId,
          fulfillmentPlanDescription: item.fulfillmentPlanDescription,
        })
      )
    },
    [cart, dispatch]
  )

  useEffect(() => {
    if (!fulfillmentPlanIdSelected) {
      setDeliveryTypeState(null)
      return
    }

    const selectedPlan = deliveryPlanData.find(
      plan => plan.fulfillmentPlanId === fulfillmentPlanIdSelected
    )

    if (selectedPlan && !hasAutoSelectedRef.current) {
      setDeliveryTypeState(selectedPlan)
      hasAutoSelectedRef.current = true
      dispatch(
        updateTemporalFulfillmentPlan({
          fulfillmentPlanId: selectedPlan.fulfillmentPlanId,
          fulfillmentPlanDescription: selectedPlan.fulfillmentPlanDescription,
        })
      )
    }
  }, [fulfillmentPlanIdSelected, deliveryPlanData, dispatch])

  return (
    <div className="delivery-plan-container">
      <h3 className="field-label">Elige un tipo de despacho</h3>

      {/* Radio buttons */}
      <div className="delivery-plan-options">
        {deliveryPlanData.map(plan => (
          <label
            key={plan.fulfillmentPlanId}
            data-testid={`delivery-plan-option-${plan.fulfillmentPlanId}`}
            className="radio-option">
            <input
              type="radio"
              name="delivery-plan"
              value={plan.fulfillmentPlanId}
              checked={
                deliveryTypeState?.fulfillmentPlanId === plan.fulfillmentPlanId
              }
              onChange={() => handleSelectDeliveryPlan(plan)}
            />
            <span>{plan.fulfillmentPlanDescription}</span>
          </label>
        ))}
      </div>

      {/* Mensaje informativo */}
      {!deliveryTypeState && (
        <div className="delivery-plan-message">
          Selecciona un plan de entrega para continuar
        </div>
      )}
    </div>
  )
}

export default DeliveryPlan
